import { Transforms, Element, NodeEntry } from 'slate';
import { v4 as uuidv4 } from 'uuid';
import { CustomEditor } from 'slate/types/slate';
import Page from 'slate/components/page/Page';
import { RenderElementProps } from 'slate-react';
import { isPage } from './utils/pageUtils';

const page =
  (options: { withButtons?: boolean; readOnly?: boolean } = {}) =>
  (editor: CustomEditor) => {
    const withButtons = options.withButtons ?? false;
    const { normalizeNode, renderElement } = editor;

    const normalizeTopLevel = (entry: NodeEntry) => {
      // TODO make sure all top level elements are pages
      normalizeNode(entry);
    };

    const normalizePage = (entry: NodeEntry) => {
      const [node, path] = entry;
      if (Element.isElement(node) && node.uuid) {
        normalizeNode(entry);
        return;
      }

      Transforms.setNodes(
        editor,
        {
          uuid: uuidv4(),
        },
        {
          at: path,
        }
      );
    };

    editor.normalizeNode = (entry) => {
      const [node, path] = entry;
      if (path.length === 0) {
        normalizeTopLevel(entry);
      } else if (isPage(node)) {
        normalizePage(entry);
      } else {
        normalizeNode(entry);
      }
    };

    editor.renderElement = (props: RenderElementProps) => {
      if (isPage(props.element)) {
        return <Page {...props} element={props.element} withButtons={withButtons} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default page;
